import axiosConfig from "./axiosConfig";

export const getAllAffiliation = async (page=1, limit=100000) => {
    try {
        let url = `v1/affiliations?limit=${limit}&page=${page}&order=desc`;
        const response = await axiosConfig.get(url);
        return response.data;
    }
    catch (error) {
        console.error('Error fetching affilconsole.liation:', error);
        throw error;
    }
}